import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js
import { useNavigate } from 'react-router-dom';

const PartyMasterList = () => {
    // State for parties and filtered parties
    const [parties, setParties] = useState([]);
    const [filteredParties, setFilteredParties] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    // Fetch parties when the component mounts
    useEffect(() => {
        fetch(`${BASE_URL}partymaster`)
            .then(response => response.json())
            .then(data => {
                setParties(data.data);
                setFilteredParties(data.data); // Set initial filtered parties
            })
            .catch(error => console.error('Error fetching parties:', error));
    }, []);

    // Handle search term change
    const handleSearchChange = (event) => {
        const term = event.target.value;
        setSearchTerm(term);

        // Filter parties based on the search term
        const filtered = parties.filter(party =>
            party.name.toLowerCase().includes(term.toLowerCase())
        );
        setFilteredParties(filtered);
    };

    // Navigate to the edit party page
    const handleEdit = (id) => {
        navigate(`/EditPartyMaster/${id}`);
    };

    // Navigate to the add party page
    const handleAdd = () => {
        navigate('/AddPartyMaster');
    };

    // Handle party deletion
    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this party?")) {
            fetch(`${BASE_URL}partymaster/${id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(response => response.json())
                .then(data => {
                    if (data.status === 1) {
                        // Remove the deleted party from both lists (parties and filteredParties)
                        setParties(parties.filter(party => party.id !== id));
                        setFilteredParties(filteredParties.filter(party => party.id !== id));
                    }
                })
                .catch(error => console.error('Error deleting party:', error));
        }
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Party Master List</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb">
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            {/* Basic Tables start */}
            <section className="section">
                <div className="row" id="basic-table">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-6">
                                    </div>
                                    <div className="col-md-6 text-end">
                                        <button className="btn btn-primary" onClick={handleAdd}>Add Customer</button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="mb-3">
                                    <label htmlFor="searchTerm" className="form-label">Search by Name</label>
                                    <input
                                        type="text"
                                        id="searchTerm"
                                        className="form-control"
                                        placeholder="Search party name"
                                        value={searchTerm}
                                        onChange={handleSearchChange}
                                    />
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-lg">
                                        <thead>
                                            <tr>
                                                <th>NAME</th>
                                                <th>EMAIL</th>
                                                <th>CONTACT</th>
                                                <th>ADDRESS</th>
                                                <th>CITY</th>
                                                <th>STATE</th>
                                                <th>TYPE</th>
                                                <th className="text-end">ACTION</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredParties.map(party => (
                                                <tr key={party.id}>
                                                    <td>{party.name || 'N/A'}</td>
                                                    <td>{party.mail_id || 'N/A'}</td>
                                                    <td>{party.number || 'N/A'}</td>
                                                    <td>{party.address || 'N/A'}</td>
                                                    <td>{party.city || 'N/A'}</td>
                                                    <td>{party.state || 'N/A'}</td>
                                                    <td>{party.type_karigar || 'N/A'}</td>
                                                    <td className="text-end">
                                                        <button className="btn btn-success" onClick={() => handleEdit(party.id)}>Edit</button>
                                                        <button className="btn btn-danger ms-2" onClick={() => handleDelete(party.id)}>Delete</button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Basic Tables end */}
        </div>
    );
};

export default PartyMasterList;
